module.exports = __webpack_public_path__ + "YI.35e4976c.png";